<template>
  <div class="middle" v-show="type!=='success'">
    <navigation :customClickEvent="true" @click="detention">优选借款</navigation>
    <div v-if="['fail','unusual'].includes(type)">
      <div class="animation-wapper">
        <img src="./images/icon_yihan@2x.png" class="fail"/>
      </div>
      <div class="text pt40">很遗憾，本次匹配失败</div>
      <div class="fail-button" v-if="['fail'].includes(type)" @click="moreProduct">更多产品</div>
      <div class="fail-button" v-else @click="reset">重新尝试</div>
    </div>
    <div v-else-if="['success'].includes(type)">
      <div class="text mt279">已为您匹配到优质借款</div>
      <div class="text2">正在前往以下产品页面</div>
      <main>
        <img :src="logo" class="icon"/>
        <div class="icon-name">{{productName}}</div>
        <!-- <div class="fail-button" @click="jump">立即前往 </div> -->
      </main>
    </div>
    <div class="river-list" v-if="['fail','unusual'].includes(type)">
      <borrow-list title="更多机会" :type="`river_diversion_${this.type}`" :source="source"/>
    </div>

    <p class="protocol">
      我们非常重视您的隐私及个人信息保护。请您认真阅读<a class="highlight" @click='routerToProtocol("/tmd/protocol/login")'>《天美贷用户注册及服务协议》</a>
      <a class="highlight" @click='routerToProtocol("/tmd/protocol/privacy")'>《天美贷隐私政策》</a>
    </p>
    <!-- 返回弹窗 -->
    <nd-dialog v-model="dialogFail" :footer="false" closeBtn>
      <div class="logout-dialog1">
        <div class="tong-guo">你已通过该产品初审</div>
        <div class="main">
          <div class="middle1">
            <img :src="riverData.icon" class="middle1-img">
            <span class="middle1-productName">{{riverData.productName}}</span>
            <div class="middle1-cornerWord" v-if="riverData.cornerWord">{{riverData.cornerWord}}</div>
          </div>
          <div class="e-du-gao-da">额度高达<span class="red">{{riverData.configLimit|toFixed}}</span>万 </div>
          <div class="nian-hua-li-lv">年化利率 {{riverData.minPrice}}%-{{riverData.maxPrice}}%</div>
        </div>
        <div class="seize" @click="goToFailBack(type)">抓住机会</div>
        <div class="give-up" @click="back">我不想要钱了</div>
      </div>
    </nd-dialog>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import BorrowList from '@/components/borrow-list'
import { hasNativeMethod, jsBridge } from '@/assets/jsBridge'
import { judgeClientSystem } from '@/assets/utils'

export default {
  name: 'river-result',
  customReadyNotify: true,
  data () {
    return {
      showGif: null,
      type: this.$route.query.type || '',
      productName: this.$route.query.productName || '', // 图标名称
      logo: this.$route.query.logo || '', // 图标
      source: this.$route.query.source,
      time: 3, // 跳转倒计时
      dialogFail: false, // 失败返回弹窗
      configLimit: this.$route.query.configLimit || '', // 传入的金额
      riverData: {} // 失败返回的数据
    }
  },
  components: {
    'borrow-list': BorrowList
  },

  created () {
    this.$bus.$emit('ready')
    this.$report({
      id: 10002,
      args: { screen: `river_diversion_${this.type}` }
    })
  },
  mounted () {
    window.addEventListener('pageshow', () => {
      if (window.isBack) {
        console.log('==========>pageshow')
        window.location.reload()
      }
    })
  },
  beforeRouteEnter (to, from, next) {
    if (to.query.from === 'r360') {
      next()
    } else {
      if (from.path === '/river/middle') {
        next((vm) => {
          const { type } = vm.$route.query || {}
          window.isBack = true
          if (type === 'success') {
            vm.jump()
          }
        })
      } else {
        next((vm) => {
          console.log('==========>before route enter')
          window.isBack = false
          vm.back()
        })
      }
    }
  },
  watch: {
    dialogFail (value) {
      const { configId } = this.riverData || {}
      this.$report({
        id: 10292,
        args: { position: `river_diversion_${this.type}`, visible: value ? 1 : 0, screen: `river_diversion_${this.type}`, target: configId }
      })
    }
  },
  methods: {
    ...mapActions(['dataPoint']),
    ...mapActions('user', ['getBorrowList']),
    // 失败申请
    goToFailBack (type) {
      const { configId, productName, logo, configLimit, needExLogin, autoJump, diversionMode } = this.riverData || {}
      let data = type === 'fail' ? 'try' : 'hold'
      this.$report({
        id: 10293,
        args: {
          screen: `river_diversion_${this.type}`, status: data, target: configId
        }
      })
      this.dataPoint(
        {
          id: 10293, screen: `river_diversion_${this.type}`, status: data, target: configId
        }
      )// 同步埋点
      this.dialogFail = false
      this.$router.push({ path: '/river/middle', query: { configId, productName, logo, configLimit, needExLogin, autoJump, diversionMode } })
    },
    // 重新尝试
    reset () {
      const { configId, directionUrl, productName, configLimit, logo, needExLogin, autoJump, diversionMode } = this.$route.query || {}
      let sourceData = this.source ? { source: decodeURIComponent(this.source) } : {}
      this.$report({ id: 10269, args: { screen: 'river_diversion_unusual', status: 'reset' } })
      this.dataPoint(
        {
          id: 10269, screen: 'river_diversion_unusual', status: 'reset'
        }
      )// 同步埋点
      this.$router.push({ path: '/river/middle', query: { directionUrl: directionUrl, configId, productName, logo, configLimit, needExLogin, autoJump, diversionMode, ...sourceData } })
    },
    // 更多产品
    jump () {
      const { directionUrl } = this.$route.query || {}
      window.location.href = decodeURIComponent(directionUrl)
    },
    // 点击返回
    async detention () {
      const response = await this.getBorrowList({ showPlace: 'ALL', queryBanner: true, dialog: true, queryChannel: 1, version: 'V2' })
      if (response.success) {
        const { configs } = response.data
        if (configs && configs.length > 0) {
          let arr = configs || []
          this.riverData = arr[0] || {}
          this.dialogFail = true
        } else {
          this.back()
        }
      } else {
        this.back()
      }
    },
    // 确认返回
    back () {
      const source = this.source ? decodeURIComponent(this.source) : undefined
      const version = this.$route.query.version
      const url = version === 'v2' ? '/river/diversion2' : '/river/diversion'
      const { to, applyNo, needQueue, from } = this.$route.query
      if (to && hasNativeMethod('exit') && judgeClientSystem() !== 'IOS') {
        jsBridge('exit')
      }
      if (to && applyNo) {
        if (needQueue) {
          this.$router.replace(
            `/authentication/wait?applyNo=${applyNo}`
          )
        } else {
          this.$router.replace(
            `/authentication/result?applyNo=${applyNo}`
          )
        }
        return
      }
      if (from === 'pre-base') {
        this.$router.go(-1)
        return
      }
      this.$router.replace(`${url}${source ? `?source=${source}` : ''}`)
    },
    // 更多产品
    moreProduct () {
      this.$report({ id: 10269, args: { screen: 'river_diversion_fail', status: 'more' } })
      this.dataPoint(
        {
          id: 10269, screen: 'river_diversion_fail', status: 'more'
        }
      )// 同步埋点
      this.back()
    }
  }
}
</script>

<style scoped lang="less">
@import "../../../assets/less/mixin.less";


.middle{
  width: 750px;
  min-height: 100%;
  background: #FAFAFA;
  padding-bottom: 60px;
  .protocol {
    line-height: 32px;
    font-size: 24px;
    padding: 0 50px;
    margin-bottom: 85px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    margin-top: 30px;
    .text {
        display: flex;
        position: relative;
        color: @fc3;
    }

    .indent {
        display: flex;
        display: inline-block;
        align-items: center;
        padding-left: 15px;
        >img{
            width:32px;
            height:32px;
            margin-right:8px;
        }
    }

    .active {
        color: #8eb2d8;
    }
}
  .text{
    text-align: center;
    font-size: 36px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #333333;
  }
  .mt279{
    margin-top:279px;
  }
  .pt40{
    padding-top:40px;
  }
  .fail-button{
    width: 320px;
    height: 80px;
    line-height: 80px;
    background: linear-gradient(90deg, #FF3333 0%, #FF5F34 100%);
    border-radius: 40px;
    text-align: center;
    font-size: 32px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
    margin:31px auto 0;
  }
  .text2{
    padding-top:8px;
    text-align: center;
    font-size: 28px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
  }
  .animation-wapper {
    margin: 139px auto 0;
    text-align: center;
    .icon{
      width:140px;
      height:140px;
    }
    .fail{
      width:100px;
      height:100px;
    }
  }
  main{
    margin-top:94px;
    display: flex;
    align-items:center;
    flex-direction:column;
    .icon{
      width:140px;
      height:140px;
      border-radius: 20px;
    }
    .icon-name{
      margin-top:22px;
      font-size: 32px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
    }
  }
  .river-list{
    margin:265px auto 0;
  }
  .logout-dialog {
      padding-top: 10px;
      padding: 0 48px;
      padding-bottom: 40px;
      font-family: PingFangSC-Regular,PingFang SC;
      .title {
          width: 380px;
          font-size: 38px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: #333333;
          margin: auto;
          text-align:center;
      }
      .description {
        text-align: center;
          width: 454px;
          font-size: 28px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #666666;
          margin:41px auto 0;
      }
      .give-up{
        font-size: 28px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #999999;
        margin-top:22px;
        text-align:center;
      }
      .seize{
        width: 440px;
        height: 80px;
        background: linear-gradient(90deg, #FF3333 0%, #FF5F34 100%);
        border-radius: 40px;
        font-size: 32px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #FFFFFF;
        text-align:center;
        margin:150px auto 0;
        line-height: 80px;
      }
  }
  .logout-dialog1 {
      padding: 60px 0 39px;
      font-family: PingFangSC-Regular,PingFang SC;
      .tong-guo{
        text-align:center;
        font-size: 36px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #333333;
      }
      .main{
        padding:0 0 0 90px;
        font-family: PingFangSC-Medium, PingFang SC;
        .middle1{
        display:flex;
        align-items:center;
        margin:84px 0 0 0;
        &-img{
            width: 48px;
            height: 48px;
            border-radius:10px;
        }
        &-productName{
            height: 40px;
            font-size: 28px;
            font-weight: 500;
            color: #333333;
            line-height: 40px;
            margin-left:12px;
            max-width:300px;
            overflow: hidden;//溢出隐藏
            white-space: nowrap;//禁止换行
            text-overflow: ellipsis;//...
        }
        &-cornerWord{
            padding:4px 10px;
            border-radius: 4px;
            border: 1px solid #FF4633;
            line-height:34px;
            text-align: center;
            font-size: 22px;
            font-weight: 400;
            color: #FF4633;
            margin-left:15px;
        }
      }
      .e-du-gao-da{
          height: 92px;
          font-size: 66px;
          font-weight: 500;
          color: #333333;
          line-height: 92px;
          margin-top:19px;
          width: 410px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
      }
      .nian-hua-li-lv{
          height: 33px;
          font-size: 24px;
          font-weight: 400;
          color: #666666;
          line-height: 33px;
      }
      .red{
          color:#FF4633;
      }
      }
      .give-up{
        font-size: 24px;
        font-weight: 400;
        color: #999999;
        margin-top:38px;
        text-align:center;
      }
      .seize{
        width: 440px;
        height: 80px;
        background: linear-gradient(90deg, #FF3333 0%, #FF5F34 100%);
        border-radius: 40px;
        font-size: 32px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #FFFFFF;
        text-align:center;
        margin:69px auto 0;
        line-height: 80px;
      }
  }
}
</style>